/**
 * Registry of per-game copy tables. A game's copy ships in its lazy module chunk and is
 * registered when the module loads, so the entry chunk holds no game text. A session cannot
 * exist before its module loads, so reasons for an unregistered game cannot occur.
 */
/** Hints v3 (D-63): 'spoken' is the full sentence (live region, accessible name); 'visible' is the short line on the board. */
export type HintVariant = 'visible' | 'spoken';

export interface GameCopy {
  hasCopy(code: string): boolean;
  /**
   * `variant` defaults to 'spoken'. A game with no visible templates yet may ignore it: 'visible'
   * then returns the spoken text, and its tests stay out of VISIBLE_READY_GAMES.
   */
  describe(code: string, params?: Record<string, string | number>, variant?: HintVariant): string;
}

const registered = new Set<GameCopy>();

export function registerGameCopy(copy: GameCopy): void {
  registered.add(copy);
}

export function findGameCopy(code: string): GameCopy | undefined {
  for (const copy of registered) if (copy.hasCopy(code)) return copy;
  return undefined;
}
